import React from 'react'
import style from 'styled-components';
import PropTypes from "prop-types";

const ContainerFlex = style.div`
width: ${(props)=> props.width};
display:${(props)=> props.display};
flex-container:${(props)=> props.type};
justify-content:${(props)=> props.justify};
`;

const ContainerGrid = style.div`
     display:${(props)=> props.display};
    grid-template-columns:${(props)=> props.type};
    gap:2.0rem;
    justify-content:${(props)=> props.justify};
    margin:2.0rem;
`;

export default function Container({width,display,type,justify,children}) {
    return (
        <>
           {display === "flex"?(
             <ContainerFlex width={width} display={display} type={type} justify={justify}>
               {children}
             </ContainerFlex>
           ):(
              <ContainerGrid width={width} display={display} type={type} justify={justify}>
                  {children}
              </ContainerGrid>
           )}
        </>
    )
}

Container.propTypes = {
    width:PropTypes.string,
    display:PropTypes.string,
    type:PropTypes.string,
    justify:PropTypes.string,
    children:PropTypes.string
};